<template>
    <div class="dealers__map-wrapper">
        <div v-if="viewtype == 'flex'" class="section__content-block dealers__flex-content">
            <div class="section__content-block-inner block-editor">
                <div v-html="content"></div>
                <form class="dealers__search-form" onsubmit="return false;">
                    <fieldset>
                        <input id="dealers__search-input" class="dealers__search-input" type="text" :placeholder="searchPlaceholder" autocomplete="off">
                        <button type="submit" class="dealers__search-submit" @click="triggerSearchOnClick()">
                            <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.2 6.49995L11.4 1.69995M16.2 6.49995L11.4 11.3M16.2 6.49995H1.20001" stroke="#01342B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </fieldset>
                </form>
            </div>
        </div>
        <div id="dealers__map-vue" class="dealers__map-vue">
            <div class="dealers__map-loader" :class="{ 'dealers__map-loader--loading' : loading }">
                <img v-bind:src="loaderSvgUrl" />
            </div>
            <div id="dealers__map-el" class="dealers__map-el" v-cloak></div>
            <div v-if="viewtype == 'page'" class="dealers__map-list">
                <form class="dealers__search-form" onsubmit="return false;">
                    <div class="dealers__search-label">{{ searchFormLabel }}</div>
                    <fieldset>
                        <input id="dealers__search-input" class="dealers__search-input" type="text" :placeholder="searchPlaceholder" autocomplete="off">
                        <button type="submit" class="dealers__search-submit" @click="triggerSearchOnClick()">
                            <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.2 6.49995L11.4 1.69995M16.2 6.49995L11.4 11.3M16.2 6.49995H1.20001" stroke="#01342B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </fieldset>
                </form>
                <div class="dealers__list">
                    <div class="dealers__count">{{ totalVisibleDealers }}  {{ dealersCountLabel }}</div>
                    <div class="dealers__list-scroller">
                        <div class="dealers__list-inner">
                            <div v-for="item in dealerItemsVisible" :key="item.slug" class="dealers__block">
                                <div class="dealers__block-title" v-html="item.title.rendered"></div>
                                <div class="dealers__block-address">
                                    <div>{{ item.acf.dealer_street_street_number }}</div>
                                    <div class="dealers__spacer">|</div>
                                    <div>{{ item.acf.dealer_postcode }} {{ item.acf.dealer_city }}</div>
                                </div>
                                <div class="dealers__block-distance" v-if="search">
                                    {{ getDealerDistanceText(item.distance) }}
                                </div>
                                <a v-if="item.acf.dealer_phone" :href="createPhoneLink(item.acf.dealer_phone)" class="dealers__iw-phone">
                                    {{ item.acf.dealer_phone }}
                                </a>
                                <a v-if="item.acf.dealer_link" :href="item.acf.dealer_link" target="_blank" rel="noopener" class="dealers__iw-web">
                                    {{ item.title.rendered }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {Loader} from "@googlemaps/js-api-loader";
import setLanguage from './mixins/setLanguage';
import determineLanguage from './mixins/determineLanguage';

export default {
    props: [
        'viewtype',
        'content'
    ],
	data() {
		return {
			mapsLoader: '',
			mapOptions: {
				zoom				: 16,
				center				: { lat: 0, lng: 0 },
				mapTypeControl 		: false,
				streetViewControl 	: false,
				zoomControl 		: true,
				styles				: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#c8d7d4"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#070707"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}],
			},
			markerImage: '',
			markerTemplate: '',
			dealerMapObj: '',
			dealerInfoWindow: '',
			totalVisibleDealers: 0,
			dealers: {
				headers: {
					totalItems: Number
				},
				items: []
			},
			loading: true,
            language: '',
            searchPlaceholder: 'plaats/posctode',
            searchFormLabel: 'Vul een plaats of postcode in',
			dealersCountLabel: 'winkel(s) gevonden:',
			baseUrl: '',
			errors: [],
            search: false,
            loaderSvgUrl: null
		};
	},
    mixins: [setLanguage, determineLanguage],
	mounted() {
        this.language = this.setLanguage();
		this.setBaseUrl();
		this.loadDealersFromAPI();
        this.setLabels();
        this.getLoaderSvg();
        this.getMarkerSvg();
	},
	methods: {
        setLabels() {
            let _this = this;
            let values = {nl: 'Vul een plaats of postcode in', en: 'Enter a city or postcode', de:'Geben Sie eine Stadt oder Postleitzahl ein'}
            _this.searchFormLabel = _this.determineLanguage(values);

            _this.searchPlaceholder = _this.determineLanguage({nl: 'Postcode of plaats', en: 'Postcode or city', de: 'Postleitzahl oder stadt'});

            _this.dealersCountLabel = _this.determineLanguage({nl: 'dealer(s) gevonden:', en: 'dealers found:', de: 'Austellungen gefunden:'});
        },
		initMap() {
			this.mapsLoader = new Loader({
				apiKey: "AIzaSyBa_90db_7JhEJ17xrijUG_w5qpUqildL8",
				version: "weekly",
				libraries: ["places"]
			});
			this.mapsLoader
				.load()
				.then((google) => {
					this.dealerMapObj = new google.maps.Map(document.getElementById("dealers__map-el"), this.mapOptions);
					this.dealerInfoWindow = new google.maps.InfoWindow({pixelOffset: 0, minWidth: 240});
					this.setMarkerImage();
					this.setMarkers();
					this.setSearch();

					let _this = this;
					google.maps.event.addListener(this.dealerMapObj, 'idle', function() {
						_this.visibleMarkers();
					});
				})
				.catch(e => {
					// do something
					console.log(e);
				});
		},
		setSearch() {
			let _this = this;
			const searchInput = document.getElementById('dealers__search-input');
			const searchBox = new google.maps.places.SearchBox(searchInput);
			searchBox.addListener("places_changed", () => {

				jQuery(".dealers").addClass("set-padding");
				jQuery(".dealers__list").addClass("show");
				jQuery(".dealers__map-list").addClass("set-height");

                this.search = true;

				const places = searchBox.getPlaces();
				const bounds = new google.maps.LatLngBounds();

                // Set maximum zoom so the chances of actually seeing a dealer in view are bigger
                _this.dealerMapObj.setOptions({ minZoom: 1, maxZoom: 11 });

                if (_this.language == 'en') {
                    _this.dealerMapObj.setOptions({ minZoom: 1, maxZoom: 9.7 });
                }

				places.forEach((place) => {
					if (!place.geometry || !place.geometry.location) {
						return;
					}

					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});

                _this.updateDealersBySearchedLocation(bounds.getCenter().lat(), bounds.getCenter().lng());
				_this.dealerMapObj.fitBounds(bounds);
				_this.visibleMarkers();

                // Reset max zoom after search
                _this.dealerMapObj.setOptions({ minZoom: 1, maxZoom: 16 });
			});
		},
		visibleMarkers() {
			let _this = this;
			let visibleMarkersDealersSlugs = [];
			let mapBounds = _this.dealerMapObj.getBounds()
			// Loop through markers
			for (var i=0; i<_this.dealerMapObj.markers.length; i++){
				// Check if marker is within view
				if(mapBounds.contains(_this.dealerMapObj.markers[i].getPosition())){
					// Grab dealer data
					var dealer = _this.dealerMapObj.markers[i];

					visibleMarkersDealersSlugs.push(dealer.dealer_slug);
				}
			}

			// Set dealers to visible if it's marker is in view
			_this.dealers.items.forEach((dealer) => {
				dealer.list_visible = visibleMarkersDealersSlugs.includes(dealer.slug);
			});

			_this.totalVisibleDealers = visibleMarkersDealersSlugs.length;

			// Set new maxZoom if no dealers visible after search
			if(_this.totalVisibleDealers === 0) {

				if ($(window).width() < 767) {
					_this.dealerMapObj.setOptions({minZoom: 1, maxZoom: 7});
				} else {
					_this.dealerMapObj.setOptions({minZoom: 1, maxZoom: 9});
				}
			}
		},
		setMarkers() {
			this.dealerMapObj.markers = [];

			for (const dealer of this.dealers.items) {

				let _this = this;

				let latlng = { lat: parseFloat(dealer.acf.dealer_address.lat), lng: parseFloat(dealer.acf.dealer_address.lng) };
				let marker = new google.maps.Marker({
					position			: latlng,
					map					: this.dealerMapObj,
					icon 				: this.markerImage,
					optimized 			: false,
					dealer_slug 		: dealer.slug
				});

				google.maps.event.addListener(marker, 'click', function() {
					_this.dealerInfoWindow.setContent(_this.createMarkerTemplate(
						dealer.title.rendered,
						dealer.acf.dealer_street_street_number,
						dealer.acf.dealer_postcode,
						dealer.acf.dealer_city,
						dealer.acf.dealer_phone,
						dealer.acf.dealer_link,
						dealer.acf.dealer_text
					));
					// _this.dealerMapObj.panTo(marker.position);
					_this.dealerInfoWindow.open(_this.dealerMapObj, marker);
				});

				this.dealerMapObj.markers.push(marker);
			}

			this.centerMap();
		},
		setMarkerImage() {
			let markerImage = {
				url: this.getMarkerSvg(),
				size: new google.maps.Size(32, 32),
				anchor: new google.maps.Point(16, 16),
				scaledSize: new google.maps.Size(32, 32),
			};
			this.markerImage = markerImage;
		},
		createMarkerTemplate(name, street, postalcode, city, phone, link, text) {
			let html = '<div class="dealers__iw">';
			html += '<div class="dealers__iw-inner">';

			if (name) {
				html += '<div class="dealers__iw-name">' + name + '</div>';
			}
			if (street) {
				html += '<div class="dealers__iw-address">' + street + '</div>';
			}
			if (postalcode && city) {
				html += '<div class="dealers__iw-address">' + postalcode + ' ' + city + '</div>';
			}

			if (phone) {
				let phone_href = phone.replace(/ |-/g, '');
				phone_href = 'tel:' + phone_href;
				html += '<a href="' + phone_href + '" class="dealers__iw-phone">' + phone + '</a>';
			}

			if (link) {
				html += '<a href="' + link + '" class="dealers__iw-web" rel="noopener" target="_blank">' + name + '</a>';
			}

			if (text) {
				html += '<div class="dealers__iw-text">' + text + '</div>';
			}

			html += '</div>';
			html += '</div>';

			return html;
		},
		centerMap() {
			let bounds = new google.maps.LatLngBounds();

			for (const marker of this.dealerMapObj.markers) {
				let latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng());
				bounds.extend(latlng);
			}

			if( this.dealerMapObj.markers.length == 1 )
			{
				// set center of map
				this.dealerMapObj.setCenter( bounds.getCenter() );
				this.dealerMapObj.setZoom( 16 );
			}
			else
			{
				this.dealerMapObj.fitBounds( bounds );
			}
			this.loading = false;
		},
		createPhoneLink(phoneNumber) {
			if (phoneNumber) {
				let phone_href = phoneNumber.replace(/ |-/g, '');
				phone_href = 'tel:' + phone_href;
				return phone_href;
			} else {
				return 'no phone number given';
			}
		},
		loadDealersFromAPI() {
			let defUrl = window.location.origin + '/wp-json/wp/v2/dealer?per_page=99';
            // if (this.language != 'en') {
            //     defUrl = window.location.origin + '/' + this.language + '/wp-json/wp/v2/dealer?per_page=99';
            // }

			axios.get(defUrl)
			.then(response => {
				this.dealers.headers.totalItems = parseInt(response.headers['x-wp-total']);

                let firstDealer = response.data[0];
                let firstLat = firstDealer.acf.dealer_address.lat;
                let firstLng = firstDealer.acf.dealer_address.lng;

				// Add 'list_visble = true' for visibility in sidebar (default all visible)
				response.data.forEach(element => {
					element.list_visible = true;
                    element.distance = this.calculateDistance(firstLat, firstLng, element.acf.dealer_address.lat, element.acf.dealer_address.lng);
				});
				this.dealers.items = response.data;
                this.sortDealersByDistance();
				this.initMap();
			})
			.catch(e => {
				this.errors.push(e)
			})
		},
        updateDealersBySearchedLocation(newLat, newLng) {
            this.dealers.items.forEach(dealer => {
                dealer.distance = this.calculateDistance(newLat, newLng, dealer.acf.dealer_address.lat, dealer.acf.dealer_address.lng);
            });

            this.sortDealersByDistance();
        },
        sortDealersByDistance() {
            this.dealers.items.sort((dealerA, dealerB) => {
                let distanceA = this.determineLanguage({nl: dealerA.distance.km, en: dealerA.distance.miles, de: dealerA.distance.km});
                let distanceB = this.determineLanguage({nl: dealerB.distance.km, en: dealerB.distance.miles, de: dealerB.distance.km});

                if (distanceA < distanceB)
                    return -1;
                if (distanceA > distanceB)
                    return 1;
                return 0;
            });
        },
		setBaseUrl() {
			this.baseUrl = window.location.origin;
		},
        calculateDistance(baseLat, baseLng, nextLat, nextLng) {
			let radlat1 = Math.PI * baseLat / 180;
			let radlat2 = Math.PI * nextLat / 180;
			let theta = baseLng - nextLng;
			let radtheta = Math.PI * theta / 180;

            let distance = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			distance = Math.acos(distance);
			distance = (distance * 180 / Math.PI) * 60 * 1.1515;
            let miles = Math.round(distance * 10) / 10;
            let km = Math.round((distance * 1.609344) * 10) /10;

            return {
                miles: miles,
                km: km
            };
        },
        getDealerDistanceText(distance) {
            if(distance === 0) {
                return this.determineLanguage({nl: 'Huidige positie', en: 'Current position', de: 'Aktuelle Position'});
            } else {
                return this.determineLanguage({nl: distance.km + ' km', en: distance.miles + ' miles', de: distance.km + ' km'});
            }
        },
        triggerSearchOnClick() {
            ga('send', 'event', 'Find-your-Dealer', 'Dealer-vinden', 'Dealer-gevonden');

            const searchInput = document.getElementById('dealers__search-input');
            google.maps.event.trigger(searchInput, 'focus', {});
            google.maps.event.trigger(searchInput, 'keydown', { keyCode: 13 });
        },
        getLoaderSvg() {
            let loaderPath = '/wp-content/themes/woodpro/src/svg/loader.svg';

            if(window.location.origin.includes('woodpro.dev')) {
                loaderPath = '/app/themes/woodpro/src/svg/loader.svg';
            }

            this.loaderSvgUrl = this.baseUrl + loaderPath;
        },
        getMarkerSvg() {
            let loaderPath = '/wp-content/themes/woodpro/src/svg/dealer-marker.svg';

            if(window.location.origin.includes('woodpro.dev')) {
                loaderPath = '/app/themes/woodpro/src/svg/dealer-marker.svg';
            }

            return this.baseUrl + loaderPath;
        }
	},
	computed: {
		dealerItemsVisible: function() {
			return this.dealers.items.filter(function (dealer) {
			  return !!(dealer.list_visible);
			})
		}
	}
};
</script>
